"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterPaymentMethodToJSON = exports.FooterPaymentMethodFromJSONTyped = exports.FooterPaymentMethodFromJSON = exports.instanceOfFooterPaymentMethod = void 0;
var runtime_1 = require("../runtime");
var FooterPaymentMethodItem_1 = require("./FooterPaymentMethodItem");
/**
 * Check if a given object implements the FooterPaymentMethod interface.
 */
function instanceOfFooterPaymentMethod(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFooterPaymentMethod = instanceOfFooterPaymentMethod;
function FooterPaymentMethodFromJSON(json) {
    return FooterPaymentMethodFromJSONTyped(json, false);
}
exports.FooterPaymentMethodFromJSON = FooterPaymentMethodFromJSON;
function FooterPaymentMethodFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'heading': !(0, runtime_1.exists)(json, 'heading') ? undefined : json['heading'],
        'methods': !(0, runtime_1.exists)(json, 'methods') ? undefined : (json['methods'] === null ? null : json['methods'].map(FooterPaymentMethodItem_1.FooterPaymentMethodItemFromJSON)),
    };
}
exports.FooterPaymentMethodFromJSONTyped = FooterPaymentMethodFromJSONTyped;
function FooterPaymentMethodToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'heading': value.heading,
        'methods': value.methods === undefined ? undefined : (value.methods === null ? null : value.methods.map(FooterPaymentMethodItem_1.FooterPaymentMethodItemToJSON)),
    };
}
exports.FooterPaymentMethodToJSON = FooterPaymentMethodToJSON;
